<div class="pane flat" *ngIf="!(loading$ | async); else loading">
  <sui-toolbar #tb>
    <sui-checkbox
      [checked]="selectAllChecked"
      (checkedChange)="onSelectAllChange($event)"
    >
      {{ "workspace-actions.button.select-all" | translate }}
    </sui-checkbox>

    <app-search-input
      [placeholder]="'workspace-actions.placeholder.search' | translate"
      [value]="filterString"
      (inputChanged)="handleObjectSearchChange($event)"
    ></app-search-input>

    <!-- Apply to selected (command menu) — no leading icon, so it stays labelled -->
    <ng-container *ngIf="applyActions.length">
      <sui-button
        variant="secondary"
        [trailingIcon]="['fas', 'caret-down']"
        [suiPopoverTrigger]="applyPanel"
        suiPopoverPlacement="bottom-start"
        #applyTrigger="suiPopoverTrigger"
        [expanded]="applyTrigger.isOpen()"
      >
        {{ applyLabel }}
      </sui-button>
      <ng-template #applyPanel>
        <div suiPopover class="dropdown-menu">
          <a
            *ngFor="let a of applyActions"
            class="dropdown-item"
            (click)="
              a.action?.(); $event.preventDefault(); $event.stopPropagation()
            "
          >
            <span class="dropdown-item-link-col1">
              <span class="dropdown-item-link-label">
                <div *ngIf="a.icon"><fa-icon [icon]="a.icon"></fa-icon></div>
                <span>{{ a.text }}</span>
              </span>
            </span>
          </a>
        </div>
      </ng-template>
    </ng-container>

    <!-- Status (first of the right-aligned group) -->
    <sui-button
      class="right-group-start"
      variant="ghost"
      [leadingIcon]="statusIcon"
      [trailingIcon]="['fas', 'caret-down']"
      [iconOnly]="tb.collapsed()"
      [ariaLabel]="tb.collapsed() ? statusLabel : undefined"
      [suiTooltip]="tb.collapsed() ? statusLabel : ''"
      [suiPopoverTrigger]="statusPanel"
      suiPopoverPlacement="bottom-end"
      #statusTrigger="suiPopoverTrigger"
      [expanded]="statusTrigger.isOpen()"
    >
      {{ tb.collapsed() ? "" : statusLabel }}
    </sui-button>
    <ng-template #statusPanel>
      <div suiPopover class="dropdown-menu">
        <div class="dropdown-heading" *ngIf="tb.collapsed()">
          {{ statusLabel }}
        </div>
        <a
          class="dropdown-item"
          (click)="
            onStatusChange(1); $event.preventDefault(); $event.stopPropagation()
          "
        >
          <span class="dropdown-item-link-col1">
            <span class="dropdown-item-link-label">
              <div><fa-icon [icon]="['fas', 'check']"></fa-icon></div>
              <span>{{ "workspace-actions.button.active" | translate }}</span>
            </span>
          </span>
          <span class="dropdown-item-link-col2">
            <input type="radio" name="lifecycle_status" [checked]="lifecycleStatus === 1" />
          </span>
        </a>
        <a
          class="dropdown-item"
          (click)="
            onStatusChange(3); $event.preventDefault(); $event.stopPropagation()
          "
        >
          <span class="dropdown-item-link-col1">
            <span class="dropdown-item-link-label">
              <div><fa-icon [icon]="['fas', 'box-archive']"></fa-icon></div>
              <span>{{ "workspace-actions.button.archived" | translate }}</span>
            </span>
          </span>
          <span class="dropdown-item-link-col2">
            <input type="radio" name="lifecycle_status" [checked]="lifecycleStatus === 3" />
          </span>
        </a>
        <a
          class="dropdown-item"
          (click)="
            onStatusChange(4); $event.preventDefault(); $event.stopPropagation()
          "
        >
          <span class="dropdown-item-link-col1">
            <span class="dropdown-item-link-label">
              <div><fa-icon [icon]="['fas', 'trash']"></fa-icon></div>
              <span>{{ "workspace-actions.button.deleted" | translate }}</span>
            </span>
          </span>
          <span class="dropdown-item-link-col2">
            <input type="radio" name="lifecycle_status" [checked]="lifecycleStatus === 4" />
          </span>
        </a>
      </div>
    </ng-template>

    <!-- View -->
    <sui-button
      variant="ghost"
      [leadingIcon]="['fas', 'eye']"
      [trailingIcon]="['fas', 'caret-down']"
      [iconOnly]="tb.collapsed()"
      [ariaLabel]="tb.collapsed() ? viewLabel : undefined"
      [suiTooltip]="tb.collapsed() ? viewLabel : ''"
      [suiPopoverTrigger]="viewPanel"
      suiPopoverPlacement="bottom-end"
      #viewTrigger="suiPopoverTrigger"
      [expanded]="viewTrigger.isOpen()"
    >
      {{ tb.collapsed() ? "" : viewLabel }}
    </sui-button>
    <ng-template #viewPanel>
      <div suiPopover class="dropdown-menu">
        <div class="dropdown-heading" *ngIf="tb.collapsed()">{{ viewLabel }}</div>
        <a
          *ngFor="let item of viewItems"
          class="dropdown-item"
          (click)="
            onViewToggle(item);
            $event.preventDefault();
            $event.stopPropagation()
          "
        >
          <span class="dropdown-item-link-col1">
            <span class="dropdown-item-link-label">
              <div *ngIf="item.icon"><fa-icon [icon]="item.icon"></fa-icon></div>
              <span>{{ item.text }}</span>
            </span>
          </span>
          <span class="dropdown-item-link-col2">
            <input
              *ngIf="item.isToggle"
              type="checkbox"
              [checked]="item.isSelected"
            />
            <input
              *ngIf="item.isRadio"
              type="radio"
              [name]="item.radioGroup"
              [checked]="item.isSelected"
            />
          </span>
        </a>
      </div>
    </ng-template>

    <!-- Sort -->
    <sui-button
      variant="ghost"
      [leadingIcon]="sortDirIcon"
      [trailingIcon]="['fas', 'caret-down']"
      [iconOnly]="tb.collapsed()"
      [ariaLabel]="tb.collapsed() ? sortLabel : undefined"
      [suiTooltip]="tb.collapsed() ? sortLabel : ''"
      [suiPopoverTrigger]="sortPanel"
      suiPopoverPlacement="bottom-end"
      #sortTrigger="suiPopoverTrigger"
      [expanded]="sortTrigger.isOpen()"
    >
      {{ tb.collapsed() ? "" : sortLabel }}
    </sui-button>
    <fa-icon class="sort-field-icon" [icon]="sortFieldIcon"></fa-icon>
    <ng-template #sortPanel>
      <div suiPopover class="dropdown-menu">
        <div class="dropdown-heading" *ngIf="tb.collapsed()">{{ sortLabel }}</div>
        <a
          class="dropdown-item"
          (click)="
            onSortFieldChange('title');
            $event.preventDefault();
            $event.stopPropagation()
          "
        >
          <span class="dropdown-item-link-col1">
            <span class="dropdown-item-link-label">
              <div><fa-icon [icon]="['fas', 'text-height']"></fa-icon></div>
              <span>{{ "workspace-actions.button.title" | translate }}</span>
            </span>
          </span>
          <span class="dropdown-item-link-col2">
            <input type="radio" name="sort" [checked]="sortField === 'title'" />
          </span>
        </a>
        <a
          class="dropdown-item"
          (click)="
            onSortFieldChange('time_created');
            $event.preventDefault();
            $event.stopPropagation()
          "
        >
          <span class="dropdown-item-link-col1">
            <span class="dropdown-item-link-label">
              <div><fa-icon [icon]="['fas', 'clock']"></fa-icon></div>
              <span>{{
                "workspace-actions.button.created-time" | translate
              }}</span>
            </span>
          </span>
          <span class="dropdown-item-link-col2">
            <input
              type="radio"
              name="sort"
              [checked]="sortField === 'time_created'"
            />
          </span>
        </a>
        <a
          class="dropdown-item"
          (click)="
            onSortFieldChange('time_modified');
            $event.preventDefault();
            $event.stopPropagation()
          "
        >
          <span class="dropdown-item-link-col1">
            <span class="dropdown-item-link-label">
              <div><fa-icon [icon]="['fas', 'clock']"></fa-icon></div>
              <span>{{
                "workspace-actions.button.modified-time" | translate
              }}</span>
            </span>
          </span>
          <span class="dropdown-item-link-col2">
            <input
              type="radio"
              name="sort"
              [checked]="sortField === 'time_modified'"
            />
          </span>
        </a>

        <div class="dropdown-divider"></div>

        <a
          class="dropdown-item"
          (click)="
            onSortDirectionChange('asc');
            $event.preventDefault();
            $event.stopPropagation()
          "
        >
          <span class="dropdown-item-link-col1">
            <span class="dropdown-item-link-label">
              <div><fa-icon [icon]="['fas', 'sort-amount-up']"></fa-icon></div>
              <span>{{ "workspace-actions.button.ascending" | translate }}</span>
            </span>
          </span>
          <span class="dropdown-item-link-col2">
            <input
              type="radio"
              name="sort-order"
              [checked]="sortDirection === 'asc'"
            />
          </span>
        </a>
        <a
          class="dropdown-item"
          (click)="
            onSortDirectionChange('desc');
            $event.preventDefault();
            $event.stopPropagation()
          "
        >
          <span class="dropdown-item-link-col1">
            <span class="dropdown-item-link-label">
              <div><fa-icon [icon]="['fas', 'sort-amount-down']"></fa-icon></div>
              <span>{{
                "workspace-actions.button.descending" | translate
              }}</span>
            </span>
          </span>
          <span class="dropdown-item-link-col2">
            <input
              type="radio"
              name="sort-order"
              [checked]="sortDirection === 'desc'"
            />
          </span>
        </a>
      </div>
    </ng-template>
  </sui-toolbar>

  <div class="scrollable-content">
    <div class="card-container-info">
      <div class="title">{{ "workspace.title.dashboards" | translate }}</div>
    </div>

    <div class="card-container mb-containers">
      <app-object-card-placeholder
        [type]="'dashboard'"
      ></app-object-card-placeholder>
      <app-object-card
        *ngFor="let dashboard of dashboards$ | async; trackBy: trackById"
        [object]="dashboard"
        [viewConfig]="viewConfig"
        [filterString]="filterString"
        [selectMode]="objectActionService.selectMode"
        [selected]="objectActionService.selectedObjects.has(dashboard.id)"
        [objectActionService]="objectActionService"
      ></app-object-card>
    </div>

    <div class="card-container-info">
      <div class="title">{{ "workspace.title.feeds" | translate }}</div>
    </div>

    <div class="card-container">
      <app-object-card-placeholder
        [type]="'feed'"
      ></app-object-card-placeholder>
      <app-object-card
        *ngFor="let feed of feeds$ | async; trackBy: trackById"
        [object]="feed"
        [viewConfig]="viewConfig"
        [filterString]="filterString"
        [selectMode]="objectActionService.selectMode"
        [selected]="objectActionService.selectedObjects.has(feed.id)"
        [objectActionService]="objectActionService"
      ></app-object-card>
    </div>

    <div class="card-container-info">
      <div class="title">{{ "workspace.title.dimensions" | translate }}</div>
    </div>
    <div class="card-container">
      <app-object-card-placeholder
        [type]="'dimension'"
      ></app-object-card-placeholder>
      <app-object-card
        *ngFor="let dimension of dimensions$ | async; trackBy: trackById"
        [object]="dimension"
        [viewConfig]="viewConfig"
        [selectMode]="objectActionService.selectMode"
        [filterString]="filterString"
        [objectActionService]="objectActionService"
        [selected]="objectActionService.selectedObjects.has(dimension.id)"
      ></app-object-card>
    </div>
  </div>
</div>
<ng-template #loading>
  <app-loading></app-loading>
</ng-template>
